<template>
  <div class="download">
    <img class="app-main" :src="url" alt="">
    <div class="app-footer">
      <div class="footer-content">
        <img v-if="brand == 'COTTI'" src="https://cdn-product-prod.cotticoffee.com/cotti_h5/images/arc.svg" alt="">
        <img v-else src="../../assets/arc.png" alt="">
        <div class="footer-main">
          <!-- <div class="footer-title">
            <img v-if="brand == 'COTTI'" src="https://cdn-product-prod.yummy.tech/cotti_h5/images/title2.png" alt="">
            <img v-else src="../../assets/download/logo-tc.png" class="img-tc" alt="">
          </div> -->
          <button :class="brand == 'COTTI' ? 'open-action' : 'open-action-tc'" @click="handleH5Download">立即下载</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import openButton from '../../components/openButton'
import {getDownloadBanner} from "../../api"
export default {
  name: 'APP',
  components:{
    openButton
  },
  data(){
    return {
      url:"",
      brand: this.$config.env.VUE_APP_BRAND
    }
  },
  mounted(){
    getDownloadBanner({"code":"Ad-sjgf-download-common"}).then(res=>this.url=res.data[0].url)
    this.handleH5Download();
  },
  methods:{
    handleH5Download () {
      if (this.brand === "COTTI") {
        window.location.href = 'https://apps.apple.com/cn/app/id1661236690'
      } else {
        window.location.href = 'https://apps.apple.com/cn/app/id6473227178'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.download{
  height: 100%;
  background: #EEEFF0;
  position: relative;
  .app-main{
    width: 100%;
  }
  .app-footer{
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    .footer-bg{
      width: 100%;
    }
    .footer-content{
      font-size: 0;
      img{
        width: 100%;
        position: relative;
        bottom: -6px;
      }
      .footer-title{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 28px 40px 56px 0;
        img{
          width: 510px;
        }
      }
      .footer-main{
        position: relative;
        z-index: 1;
        min-height: 210px;
        padding-bottom: 26px;
        background: white;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      .app-open{
        .open-action{
          width: 562px;
          height: 96px;
          border-radius: 48px;
          background: white;
          border: 1px solid #FF6A39;
          font-size: 32px;
          font-weight: 500;
          color: #FF6A39;
          line-height: 94px;
          text-align: center;
        }
      }

    }
  }

  .open-action{
    background: #A52337;
    width: 542px;
    height: 90px;
    border-radius: 46px;
    box-shadow: 0px 2px 4px 0px rgba(143,92,92,0.12);
    font-size: 32px;
    font-weight: 500;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
    margin-bottom: 24px;
  }
  .open-action-tc{
    background: #9FCC0C;
    width: 542px;
    height: 90px;
    border-radius: 46px;
    box-shadow: 0px 2px 4px 0px rgba(143,92,92,0.12);
    font-size: 32px;
    font-weight: 500;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
    margin-bottom: 24px;
  }
}
</style>
